<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <h1
        class="text-xl sm:text-2xl lg:text-3xl font-semibold"
        :class="{ 'font-inter': locale == 'vi' }"
      >
        {{ current_tool.h1 }}
      </h1>
      <button @click="openYoutube"
        class="rounded-lg hidden h-11 px-5 bg-[#ff0000] text-white font-bold whitespace-nowrap transition md:inline-flex items-center"
      >
        <BrandYoutubeIcon class="font-bold mr-2" />
        Video Guide
      </button>
    </div>
    <!-- <ul
      class="flex items-center gap-2 max-w-full overflow-x-auto overflow-y-hidden pb-4 lg:pb-0"
      ref="nav_tools"
    >
      <li
        v-for="tool in tools"
        :class="{
          'tool-active text-xl down-mark-line text-success pb-2': tool.current,
          'text-base': !tool.current,
        }"
        :id="tool.slug ? tool.slug : 'text'"
      >
        <div :class="{ 'font-esbuild': tool.current }">
          <nuxt-link
            :to="localePath('/' + tool.slug)"
            class="p-3 whitespace-nowrap"
            >{{ tool.name }}</nuxt-link
          >
        </div>
      </li>
    </ul> -->
    <div class="overflow-hidden relative">
      <div
        class="w-fit bg-white sm:p-4 p-3 border border-gray-200 rounded-lg"
        ref="emblaNode"
      >
        <div
          class="flex flex-nowrap items-center sm:select-none select-auto gap-x-2"
        >
          <div
            v-for="(tool, i) in tools"
            :key="i"
            class="relative shrink-0 py-2 sm:px-4 px-3 text-base sm:text-lg"
            :class="{
              'bg-success font-semibold text-white rounded-md': tool.current,
              'text-neutral-800': !tool.current,
            }"
          >
            <PartialsToolIcon
              :name="tool.name"
              :slug="tool.slug"
              :icon="tool.icon"
            />
          </div>
        </div>
      </div>
      <div
        @click="prevSlide"
        v-if="showPrev"
        title="prev"
        class="absolute -left-0 w-6 h-6 bg-white border border-neutral-200 z-[1] top-1/2 -translate-y-1/2 text-lg rounded-full inline-flex items-center justify-center focus:outline-none"
      >
        <ChevronLeftIcon />
      </div>
      <div
        @click="nextSlide"
        v-if="showNext"
        :title="$t('next')"
        class="absolute -right-0 w-6 h-6 bg-white border border-neutral-200 z-[1] top-1/2 -translate-y-1/2 text-lg rounded-full inline-flex items-center justify-center focus:outline-none"
      >
        <ChevronRightIcon />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import EmblaCarousel from "embla-carousel-vue";
const [emblaNode, emblaApi] = EmblaCarousel({
  loop: false,
  align: "start",
  breakpoints: {
    "(max-width: 640px)": { dragFree: true, },
  },
});
import {
  BrandYoutubeIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "vue-tabler-icons";
import { useLimit } from "~~/stores/limit";
const nav = ref<HTMLElement | null>(null);
const { locale } = useI18n();
const props = defineProps({
  tools: {
    type: Array<{
      name: string;
      keys?: string;
      slug: string;
      title?: string;
      description?: string;
      current?: boolean;
      h1?: string;
      icon: string;
    }>,
    default: [],
  },
  current_tool: {
    type: Object as PropType<{
      name: string;
      keys?: string;
      slug: string;
      title?: string;
      description?: string;
      current?: boolean;
      h1?: string;
    }>,
    required: true,
  },
});
const showPrev = ref(false);
const showNext = ref(true);
const nextSlide = () => {
  emblaApi.value?.scrollNext();
};
const prevSlide = () => {
  emblaApi.value?.scrollPrev();
};
const slideChanged = () => {
  if (emblaApi.value) {
    console.log(emblaApi.value.slidesInView())
    if (emblaApi.value.slidesInView().includes(props.tools.length - 1)) {
      showNext.value = false;
    } else {
      showNext.value = true;
    }
    if (emblaApi.value.slidesInView().includes(0)) {
      showPrev.value = false;
    } else {
      showPrev.value = true;
    }
  }
};
watchEffect(() => {
  if (!emblaApi.value) return;
  emblaApi.value.on("select", slideChanged);
});

const nav_tools = ref<HTMLElement>();
const localePath = useLocalePath();
const route = useRoute();
const device = useDevice();
onMounted(() => {
  nextTick(() => {
    var index = 0;
    for (let i = 0; i < props.tools.length; i++) {
      if (props.tools[i].current) {
        index = i;
        break;
      }
    }

    if (device.isMobileOrTablet) {
      emblaApi.value?.scrollTo(index);
    }
  });
});
const openYoutube = ()=>{
  useUtils().redirectUrl('https://www.youtube.com/@QRGateway/videos')
}
</script>
<style lang="scss">
@import "~/assets/styles/variables";
</style>
